import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material'
import { ChangeEvent } from 'react'

interface Props {
    label: string
    value: boolean
    name?: string
    onChange?: (event: ChangeEvent<HTMLInputElement>) => void
    className?: string
    disabled?: boolean
}

const radioButtonStyles = {
    '& .MuiSvgIcon-root': {
        fontSize: '18px',
        '@media (min-width: 768px)': {
            fontSize: '24px',
        },
    },
}

const labelStyles = {
    '& .MuiFormControlLabel-label': {
        fontSize: '12px',
        marginLeft: '-5px',
        '@media (min-width: 768px)': {
            fontSize: '16px',
            marginLeft: '0px',
        },
    },
}

const CustomRadioButton = ({ label, value, onChange, name, className, disabled }: Props) => {
    return (
        <div className={`flex items-center gap-2 md:gap-4 ${className}`}>
            <span>{label}</span>
            <div className="min-w-[100px] md:min-w-[130px]">
                <FormControl>
                    <RadioGroup
                        row
                        name={name}
                        value={value}
                        onChange={onChange}
                    >
                        <FormControlLabel
                            value={true}
                            control={
                                <Radio
                                    sx={radioButtonStyles}
                                    className="text-primary"
                                />
                            }
                            label="Sí"
                            disabled={disabled}
                            sx={labelStyles}
                        />
                        <FormControlLabel
                            value={false}
                            control={
                                <Radio
                                    sx={radioButtonStyles}
                                    className="text-primary"
                                />
                            }
                            label="No"
                            disabled={disabled}
                            sx={labelStyles}
                        />
                    </RadioGroup>
                </FormControl>
            </div>
        </div>
    )
}

export default CustomRadioButton
